import axios from "axios"

export const show = async ({ params }) => {
    var access_token = localStorage.getItem('access_token') ?? ''

    return axios({method: 'get', url: `${process.env.REACT_APP_REMAX_PS_API_URL}/return_header_all`,
        params: {id: params.id},
        headers: 
        {
            'Authorization': `Bearer ${access_token}` 
        }}).then(res => res.data)
}
